import maplibregl, { Map } from 'maplibre-gl';
import { getGroupedBounds } from '@/utils/map';
import { IPoint } from '@/types/map';
import {
  LAYER_ID as ROADS_LAYER_ID,
  roadLayers,
} from '@/components/ui/map/styles/RoadLayers';
import vectorMap from '../styles/VectorMap';

export const LAYER_ID = 'hm-raster-tiles-layer';
export const SOURCE_ID = 'hm-raster-tiles-source';

interface GetGroupedBoundsParams {
  lat: number;
  lon: number;
  points?: IPoint[];
  mapContainerCurrent: HTMLElement;
}

export const getMapLibreBaseMap = ({
  lat,
  lon,
  points = [],
  mapContainerCurrent,
}: GetGroupedBoundsParams): Map => {
  const bounds = getGroupedBounds({ lat, lon }, points);

  const map = new maplibregl.Map({
    bounds,
    container: mapContainerCurrent,
    style: {
      version: 8,
      glyphs:
        'https://protomaps.github.io/basemaps-assets/fonts/{fontstack}/{range}.pbf',
      sources: {
        [SOURCE_ID]: {
          type: 'raster',
          tiles: [`https://sat-raster-tiles.hivemapper.com/{z}/{x}/{y}`],
          tileSize: 256,
        },
        'vector-hm': {
          type: 'vector',
          tiles: [
            'https://vector-pmtiles.hivemapper.com/protomaps-basemap-opensource-20230408/{z}/{x}/{y}.mvt',
          ],
          maxzoom: 14,
        },
      },
      layers: [
        {
          id: LAYER_ID,
          source: SOURCE_ID,
          type: 'raster',
        },
        ...roadLayers,
      ],
    },
    maxPitch: 0,
    minZoom: 15,
    maxZoom: 21,
  });

  map.addControl(
    new maplibregl.NavigationControl({
      showCompass: true,
      visualizePitch: false,
      showZoom: false,
    }),
  );
  map.keyboard.disable();

  return map;
};

export const getAzimuthBaseMap = ({
  lat,
  lon,
  points = [],
  mapContainerCurrent,
}: GetGroupedBoundsParams): Map => {
  const bounds = getGroupedBounds({ lat, lon }, points);

  const map = new maplibregl.Map({
    bounds,
    container: mapContainerCurrent,
    style: vectorMap,
    maxPitch: 0,
    minZoom: 10,
  });

  map.addControl(
    new maplibregl.NavigationControl({
      showCompass: true,
      visualizePitch: false,
      showZoom: false,
    }),
  );
  map.keyboard.disable();

  return map;
};

export function addLayer(map: Map) {
  if (!map.getLayer(LAYER_ID)) {
    map.addLayer(
      {
        id: LAYER_ID,
        source: SOURCE_ID,
        type: 'raster',
      },
      ROADS_LAYER_ID,
    );
  }
}

export function removeLayer(map: Map) {
  if (map.getLayer(LAYER_ID)) {
    map.removeLayer(LAYER_ID);
  }
}
